/**
 * UXP manifest id — mirrors `plugins/premiere/manifest.json`. Used as `event.origin` on host→WebView messages.
 */
export const PREMIERE_PLUGIN_ID = '6b6bd853';

/** Beta sideload ids; remove once installed betas are negligible. */
export const PREMIERE_PLUGIN_LEGACY_IDS = ['com.air.premiere-plugin'] as const;

const TRUSTED_PREMIERE_PLUGIN_ORIGINS = new Set<string>([PREMIERE_PLUGIN_ID, ...PREMIERE_PLUGIN_LEGACY_IDS]);

export const isTrustedPremierePluginOrigin = (origin: string): boolean => {
  return TRUSTED_PREMIERE_PLUGIN_ORIGINS.has(origin);
};
